import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Roles from 'spark-types/Roles';
import * as permissionConfig from '../config/actions';
// SAF-20237: Import module-specific recipient checks for granular permissions (Role Assignment - Switch Roles and its Precedence - PSR-4763)
import { isRecipient, isSafetyRecipient, isGapPacketRecipient, isIBRecipient, userHasRole, isEnterpriseAdmin } from 'spark-state/common/user/userReducer';

/**
 * @param {Object} state Redux state
 * @param {String} requires String of format "module.actionName" (see config/actions.js)
 * @returns {Boolean} if user has permisison
 */
const checkAction = (state, requires) => {
	const [ moduleName, actionName ] = requires.split('.');
	return permissionConfig[moduleName][actionName].roles.some(
		(role) => (role === Roles.ENTERPRISE_ADMIN ? isEnterpriseAdmin(state) : userHasRole(state, role))
	);
};

// SAF-20237: Support module-specific recipient permission checks (Role Assignment - Switch Roles and its Precedence - PSR-4763)
const Permission = ({ requires = '', recipientOnly, safetyRecipientOnly, gpRecipientOnly, ibRecipientOnly, render, children }) => {
	const hasPermission = useSelector(state =>
		recipientOnly ? isRecipient(state)
			: safetyRecipientOnly ? isSafetyRecipient(state)
			: gpRecipientOnly ? isGapPacketRecipient(state)
			: ibRecipientOnly ? isIBRecipient(state)
			: checkAction(state, requires)
	);

	if (render) {
		return render(hasPermission);
	}
	return hasPermission ? children : null;
};

Permission.propTypes = {
	requires: PropTypes.string,
	recipientOnly: PropTypes.bool,
	safetyRecipientOnly: PropTypes.bool,
	gpRecipientOnly: PropTypes.bool,
	ibRecipientOnly: PropTypes.bool
};

export default Permission;
